import * as _ from 'lodash';

// Backend split read-shape:
//   *PodSettings              -> POD status enum: "Required" | "Optional" | "NotRequired"
//   *PodFillRequiredSettings  -> boolean per POD key
//
// `task.taskSpec.identifications` is the legacy mixed write-shape: POD as
// boolean + `is{PodKey}FillRequired` as boolean in the same object. The
// helpers below tell the two families apart inside that mixed object.

export type BooleanMap = { [key: string]: boolean };

export type PodSettingsMap = { [key: string]: string | boolean };

const MANDATORY_KEY_PREFIX = 'is';
const MANDATORY_KEY_SUFFIX = 'FillRequired';

export function isMandatoryFlagKey(key: string): boolean {
  return _.startsWith(key, MANDATORY_KEY_PREFIX) && _.endsWith(key, MANDATORY_KEY_SUFFIX);
}

export function getMandatoryKey(podKey: string): string {
  return MANDATORY_KEY_PREFIX + _.upperFirst(podKey) + MANDATORY_KEY_SUFFIX;
}
